<template>

    <div>

        <treeselect
            :multiple="true"
            :clearable="false"
            :searchable="true"
            :options="options"
            :max-height="200"
            :flat="true"
            v-model="value"
        >
            <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
            <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                {{ node.raw.name }}
                <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
            </label>
        </treeselect>

        <input type="hidden" name="category_ids" :value="value" />

    </div>

</template>

<script>
  // import the component
  import Treeselect from '@riophae/vue-treeselect';
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';

  export default {
    // register the component
    components: { Treeselect },
    props: {
      options: {
        default: [],
      },
      preselected: {
        default: [],
      }
    },
    data() {

      return {
        // define default value
        value: this.preselected,
        // define options
        // options: ,
      };
    }
  };

</script>

<style>

    .vue-treeselect__placeholder,
    .vue-treeselect__single-value {
        line-height: 40px;
    }

    .vue-treeselect__control {

        background-color: #fff;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        height: 40px;

    }

</style>